import { ref } from 'vue'

// Cada rota carrega a sua view sob demanda (`component: () => import(...)`), então entre o clique
// e a montagem do componente existe uma janela de download. O overlay de loading de cada página
// vive DENTRO da própria página, ou seja, só aparece depois dessa janela — o usuário clica e não
// vê nada acontecer. Este store cobre exatamente esse intervalo, dirigido pelos guards do router.

// Navegação cujo chunk já está em cache resolve em poucos milissegundos, e piscar um overlay
// nesses casos incomoda mais do que ajuda. Só mostramos se a resolução passar deste tempo.
const SHOW_DELAY_MS = 150

const isLoading = ref(false)
let timer = null

const start = () => {
  clearTimeout(timer)
  timer = setTimeout(() => {
    isLoading.value = true
  }, SHOW_DELAY_MS)
}

const stop = () => {
  clearTimeout(timer)
  timer = null
  isLoading.value = false
}

export default {
  isLoading,
  start,
  stop
}
